// Hedef takibi + disclosure hazırlık (TODO-KPI-01 / TODO-KPI-08) — /api/v1/kpi/sets/:setId/{targets,disclosure}
// typed wrapper'ları (route'lar: routes/kpi-targets.ts, routes/kpi-disclosure.ts).

import type {
  KpiDisclosureSummary,
  KpiTarget,
  KpiTargetUpsert,
  KpiTargetWithProgress,
} from "@mahir/shared";
import { api } from "./client";

export async function listKpiTargets(setId: string): Promise<KpiTargetWithProgress[]> {
  const res = await api<{ targets: KpiTargetWithProgress[] }>(`/kpi/sets/${setId}/targets`);
  return res.targets;
}

/** `body.id` varsa güncelleme (200), yoksa yeni hedef (201). */
export async function upsertKpiTarget(setId: string, body: KpiTargetUpsert): Promise<KpiTarget> {
  const res = await api<{ target: KpiTarget }>(`/kpi/sets/${setId}/targets`, {
    method: "PUT",
    body,
  });
  return res.target;
}

export async function deleteKpiTarget(setId: string, targetId: string): Promise<void> {
  await api<{ deleted: boolean }>(`/kpi/sets/${setId}/targets/${targetId}`, {
    method: "DELETE",
  });
}

export async function getKpiDisclosure(
  setId: string,
  opts: { standard?: string; year?: number } = {},
): Promise<KpiDisclosureSummary> {
  const q = new URLSearchParams();
  if (opts.standard) q.set("standard", opts.standard);
  if (opts.year) q.set("year", String(opts.year));
  const qs = q.toString();
  return api(`/kpi/sets/${setId}/disclosure${qs ? `?${qs}` : ""}`);
}
